import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/Opciones.css';

function Opciones() {
    const [loading, setLoading] = useState(false);

    const options = [
        { 
            path: '/donantes', 
            icon: 'fa-users', 
            text: 'Donantes',
            description: 'Gestionar donantes y roles'
        },
        { 
            path: '/ingresos', 
            icon: 'fa-money-bill-wave', 
            text: 'Ingresos',
            description: 'Gestionar ingresos y donaciones'
        },
        { 
            path: '/egresos', 
            icon: 'fa-minus-circle', 
            text: 'Egresos',
            description: 'Administrar gastos y pagos'
        },
        { 
            path: '/reporteingresos', 
            icon: 'fa-chart-line', 
            text: 'Reporte Ingresos',
            description: 'Ver informes detallados de ingresos'
        },
        { 
            path: '/reporteegresos', 
            icon: 'fa-chart-bar', 
            text: 'Reporte Egresos',
            description: 'Analizar gastos y egresos'
        },
        { 
            path: '/reporteconsolidado', 
            icon: 'fa-chart-pie', 
            text: 'Reporte Consolidado',
            description: 'Vista general de finanzas'
        }
    ];

    const handleClick = (path) => {
        setLoading(true);
        try {
            // Simular una pequeña carga para mejor UX
            setTimeout(() => {
                setLoading(false);
            }, 300);
        } catch (error) {
            toast.error('Error al navegar. Por favor intente nuevamente.');
            setLoading(false);
        }
    };

    return (
        <div className="opciones-container">
            <ToastContainer position="top-right" autoClose={3000} />
            <h1 className="opciones-title">
                <i className="fas fa-church opciones-title-icon"></i>
                Administración Financiera
            </h1>
            <p className="opciones-description">
                Seleccione una opción para gestionar los recursos de la iglesia
            </p>
            <div className="opciones-grid">
                {options.map((option, index) => (
                    <Link
                        key={index}
                        to={option.path}
                        className="opciones-card"
                        onClick={() => handleClick(option.path)}
                    >
                        <i className={`fas ${option.icon} opciones-card-icon`}></i>
                        <h3>{option.text}</h3>
                        <p>{option.description}</p>
                        {loading && <div className="loading-spinner"></div>}
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Opciones;
